define( function() {
	return ( /<([\w:-]+)/ );
} );



// WEBPACK FOOTER //
// ./~/jquery/src/manipulation/var/rtagName.js